import { OrganizationSchema, WebSiteSchema, LocalBusinessSchema } from '../../utils/seo';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import CoreTechnologySection from './components/CoreTechnologySection';
import PortfolioSection from './components/PortfolioSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <LocalBusinessSchema />
      <div className="min-h-screen">
        <Header />
        <main>
          <div id="home">
            <HeroSection />
          </div>
          <div id="about">
            <AboutSection />
          </div>
          <div id="core-technology">
            <CoreTechnologySection />
          </div>
          <div id="portfolio">
            <PortfolioSection />
          </div>
          <div id="services">
            <ServicesSection />
          </div>
          <div id="contact">
            <ContactSection />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
